<ul *ngIf="tipologie" class="list-inline mb-0">
    <li *ngIf="tipologie.includes('D')" class="list-inline-item"
        matTooltip="{{ 'generale.degustazione' | translate | uppercase }}">
        <div class="icona-servizio">
            <img src="../../../../assets/img/servizi/D.png" alt="{{ 'generale.degustazione' | translate | uppercase }}"
                title="{{ 'generale.degustazione' | translate | uppercase }}" width="16px" height="16px">
        </div>
    </li>
    <li *ngIf="tipologie.includes('W')" class="list-inline-item"
        matTooltip="{{ 'generale.degustazioneweb' | translate | uppercase }}">
        <div class="icona-servizio">
            <img src="../../../../assets/img/servizi/W.png"
                alt="{{ 'generale.degustazioneweb' | translate | uppercase }}"
                title="{{ 'generale.degustazioneweb' | translate | uppercase }}" width="16px" height="16px">
        </div>
    </li>
    <li *ngIf="tipologie.includes('R')" class="list-inline-item"
        matTooltip="{{ 'generale.ristorazione' | translate | uppercase }}">
        <div class="icona-servizio">
            <img src="../../../../assets/img/servizi/R.png" alt="{{ 'generale.ristorazione' | translate | uppercase }}"
                title="{{ 'generale.ristorazione' | translate | uppercase }}" width="16px" height="16px">
        </div>
    </li>
    <li *ngIf="tipologie.includes('P')" class="list-inline-item"
        matTooltip="{{ 'generale.pernottamento' | translate | uppercase }}">
        <div class="icona-servizio">
            <img src="../../../../assets/img/servizi/P.png" alt="{{ 'generale.pernottamento' | translate | uppercase }}"
                title="{{ 'generale.pernottamento' | translate | uppercase }}" width="16px" height="16px">
        </div>
    </li>
    <li *ngIf="tipologie.includes('C')" class="list-inline-item"
        matTooltip="{{ 'generale.picnic' | translate | uppercase }}">
        <div class="icona-servizio">
            <img src="../../../../assets/img/servizi/C.png" alt="{{ 'generale.picnic' | translate | uppercase }}"
                title="{{ 'generale.picnic' | translate | uppercase }}" width="16px" height="16px">
        </div>
    </li>
    <li *ngIf="tipologie.includes('T')" class="list-inline-item"
        matTooltip="{{ 'generale.espdeluxe' | translate | uppercase }}">
        <div class="icona-servizio">
            <img src="../../../../assets/img/servizi/T.png" alt="{{ 'generale.picnic' | translate | uppercase }}"
                title="{{ 'generale.picnic' | translate | uppercase }}" width="16px" height="16px">
        </div>
    </li>
    <li *ngIf="tipologie.includes('V')" class="list-inline-item"
        matTooltip="{{ 'generale.vino' | translate | uppercase }}">
        <div class="icona-servizio">
            <img src="../../../../assets/img/servizi/V.png" alt="{{ 'generale.vino' | translate | uppercase }}"
                title="{{ 'generale.vino' | translate | uppercase }}" width="16px" height="16px">
        </div>
    </li>
</ul>